import React from 'react';
import GeckoFieldBase from '../_base';

class GeckoFieldPassword extends GeckoFieldBase {

	attrs() {
		return {
			id             : this.renderId(),
			[`aria-label`] : this.renderAriaLabel(),
			className      : 'file:text-foreground placeholder:text-slate-500 selection:bg-primary selection:text-primary-foreground border-input flex h-9 w-full min-w-0 rounded-sm border bg-transparent px-3 py-1 text-base transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm focus-visible:border-slate-500 focus-visible:ring-slate-400/50 focus-visible:ring-[3px] aria-invalid:ring-destructive/20 aria-invalid:border-destructive autofill:font-sans autofill:bg-white autofill:text-foreground autofill:shadow-[0_0_0_1000px_#fff_inset]',
			type           : 'password',
			disabled       : this.isDisabled(),
			onChange       : this.handleChange.bind(this),
			onBlur         : this.handleBlur.bind(this),
			placeholder    : this.config().placeholder || this.field().placeholder,
			value          : this.value(),
			name: this.name(),
			ref: this.ref(),
			...this.attributes()
		};
	}

	render() {
		return (<input {...this.attrs()} autoComplete="current-password" />);
	}
}

export default GeckoFieldPassword;